import { Directive, ElementRef, effect, inject, input } from '@angular/core';

/**
 * Directive that sets a fallback image when the host <img> element fails to load.
 *
 * Usage:
 *   <img [src]="imageUrl" appProductImgFallback />  <!-- uses default fallback -->
 */
@Directive({
  selector: 'img[appProductImgFallback]',
  host: {
    '(error)': 'onError()',
  },
})
export class ProductImgFallbackDirective {
  private readonly fallback = '/images/product-without-picture.jpg';
  readonly src = input<string | undefined | null>();

  private readonly el = inject(ElementRef<HTMLImageElement>);

  constructor() {
    effect(() => {
      const source = this.src();
      this.el.nativeElement.src = source || this.fallback;
    });
  }

  onError(): void {
    const img = this.el.nativeElement;
    // Prevent infinite loop if the fallback itself fails
    if (img.src !== this.fallback && !img.src.includes(this.fallback)) {
      img.src = this.fallback;
    }
  }
}
